(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("aws_amplify_ui", [], factory);
	else if(typeof exports === 'object')
		exports["aws_amplify_ui"] = factory();
	else
		root["aws_amplify_ui"] = factory();
})(window, function() {
return 